import {createSlice} from '@reduxjs/toolkit'
// @ts-ignore
import Toastify from 'toastify-js'
import 'toastify-js/src/toastify.css'

// Statuses SetupAxios already surfaces: 401 redirects to /logout and 5xx opens a
// "Server is not reachable" dialog. Toasting those again would double up.
const REPORTED_BY_INTERCEPTOR = [401, 500, 501, 502]

// The API sends its own message on handled failures; class-validator sends an
// array. Fall back to the clientMessage each action sets before dispatching.
const failureMessage = (error: any): string => {
  const apiMessage = error?.response?.data?.message
  if (Array.isArray(apiMessage) && apiMessage.length) return apiMessage.join(', ')
  if (typeof apiMessage === 'string' && apiMessage.trim()) return apiMessage
  return error?.clientMessage || error?.message || 'Something went wrong. Please try again.'
}

const initialCommonState: ICommonState = {
  listLoading: false,
  actionsLoading: false,
  error: '',
  statistics: [],
  inspectionsCalenderData: [],
}

export interface ICommonState {
  listLoading: boolean
  actionsLoading: boolean
  error: string
  statistics: []
  inspectionsCalenderData: []
}

export const callTypes = {
  list: 'list',
  action: 'action',
}

export const CommonSlices = createSlice({
  name: 'common',
  initialState: initialCommonState,
  reducers: {
    catchError: (state, action) => {
      const {error} = action.payload
      state.error = `${action.type}: ${error}`
      if (!REPORTED_BY_INTERCEPTOR.includes(error?.response?.status)) {
        Toastify({
          text: failureMessage(error),
          duration: 3000,
          newWindow: true,
          gravity: 'top',
          position: 'right',
          className: 'toastify-error',
          stopOnFocus: true,
        }).showToast()
      }
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false
      } else {
        state.actionsLoading = false
      }
    },
    startCall: (state, action) => {
      state.error = ''
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true
      } else {
        state.actionsLoading = true
      }
    },
    endCall: (state, action) => {
      state.error = ''
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false
      } else {
        state.actionsLoading = false
      }
    },
    dashboardStatistics: (state, action) => {
      state.actionsLoading = false
      state.error = ''
      state.statistics = action.payload
    },
    inspectionsCalenderData: (state, action) => {
      state.actionsLoading = false
      state.error = ''
      state.inspectionsCalenderData = action.payload.inspections
    },
    resetCalenderData: (state, action) => {
      state.inspectionsCalenderData = action.payload
    },
  },
})

export const {catchError, startCall, endCall} = CommonSlices.actions
